<template>
  <div>
    <!-- <div class="row">
      <div class="ml-auto" style="min-width: 200px">
       
        <div class="input-group">
          <span class="input-group-text bg-white"
            style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right: none">
            <i class="fas fa-calendar"
              style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #333"></i>
          </span>
          <flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date"></flat-pickr>
        </div>
      </div>
    </div> -->

    <!-- Stats Start -->
    <div id="view-stats" class="row mb-4">
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats title="Total Report Suspect" :tooltipText="'Total Report Suspect'"
            :tooltipBody="'Jumlah laporan kode QR yang dianggap mencurigakan'"
            :value="reportSuspectData.stats.total_report" unit="Activities" :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFEECE' />
                <path
                    d='M28.4448 35.2515C28.7953 35.2515 29.0892 35.1327 29.3266 34.8953C29.5641 34.6578 29.6824 34.3643 29.6816 34.0147C29.6807 33.6652 29.562 33.3717 29.3254 33.1342C29.0888 32.8968 28.7953 32.778 28.4448 32.778C28.0944 32.778 27.8009 32.8968 27.5643 33.1342C27.3277 33.3717 27.209 33.6652 27.2081 34.0147C27.2073 34.3643 27.326 34.6582 27.5643 34.8965C27.8026 35.1348 28.0961 35.2531 28.4448 35.2515ZM27.2081 30.3046H29.6816V22.8843H27.2081V30.3046ZM23.8072 40.1983L17.3145 33.7056V24.4302L23.8072 17.9375H33.0825L39.5752 24.4302V33.7056L33.0825 40.1983H23.8072Z'
                    fill='#E8A527'
                />
                </svg>
            `"></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats title="Scan More Than 5" :tooltipText="'Scan More Than 5'"
            :tooltipBody="'Jumlah kode QR yang melakukan scan lebih dari 5 kali'"
            :value="reportSuspectData.stats.scan_more_than_5" unit="Activities" :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#F1EDFD'/>
                <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M19.6035 30.1266V28.3266H37.6035V30.1266H19.6035ZM32.2035 38.2266V36.4266H35.8035V32.8266H37.6035V36.4266C37.6035 37.4207 36.8709 38.2266 35.9672 38.2266H32.2035ZM25.0035 38.2266H21.2399C20.3361 38.2266 19.6035 37.4207 19.6035 36.4266V32.8266H21.4035V36.4266H25.0035V38.2266ZM32.2035 20.2266H35.9672C36.8709 20.2266 37.6035 21.0324 37.6035 22.0266V25.6266H35.8035V22.0266H32.2035V20.2266ZM25.0035 20.2266V22.0266H21.4035V25.6266H19.6035V22.0266C19.6035 21.0324 20.3361 20.2266 21.2399 20.2266H25.0035Z'
                    fill='#A94AE4'
                    stroke='#A94AE4'
                />
                </svg>
            `" circle_bg_color="#ecf5fb" circle_text_color="#267de4"></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats title="Scan Different Location" :tooltipText="'Scan Different Location'"
            :tooltipBody="'Jumlah kode QR yang melakukan scan di tempat berbeda dalam jarak lebih dari 100 meter dari scan pertama'"
            :value="reportSuspectData.stats.scan_different_location" unit="Activities" :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#ECF5FB'/>
                <path d='M39.5752 35.0395V28.0311C39.5752 26.7399 39.5752 26.0944 39.2253 25.6083C38.9421 25.2163 38.4882 25.0073 37.6794 24.7266C37.5136 26.7127 36.8557 28.7422 35.8231 30.5168C34.6197 32.5846 32.8327 34.4335 30.5435 35.4315C29.8813 35.7192 29.1669 35.8676 28.4448 35.8676C27.7228 35.8676 27.0084 35.7192 26.3462 35.4315C24.057 34.4335 22.27 32.5846 21.0666 30.5168C20.282 29.1681 19.7246 27.6995 19.4169 26.1698C18.9432 26.0993 18.5808 26.1352 18.2667 26.3096C18.142 26.3796 18.0258 26.4638 17.9204 26.5606C17.3145 27.1122 17.3145 28.1374 17.3145 30.1891V36.2861C17.3145 37.576 17.3145 38.2215 17.6644 38.7076C18.0144 39.1936 18.6266 39.3977 19.8509 39.8058L20.3258 39.9641C22.2761 40.6133 23.2507 40.9386 24.2487 40.9411C24.5488 40.9411 24.8481 40.9196 25.1465 40.8768C26.1334 40.7345 27.061 40.2708 28.916 39.3432C30.337 38.6321 31.0481 38.2772 31.8025 38.1127C32.0672 38.055 32.3351 38.0146 32.6064 37.9915C33.3769 37.9272 34.1523 38.0571 35.7068 38.3155C37.2811 38.5777 38.0689 38.7088 38.644 38.3786C38.8411 38.2657 39.0113 38.1214 39.1548 37.9458C39.5752 37.4325 39.5752 36.6349 39.5752 35.0395Z' fill='#267CE5'/>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M28.4437 16.6992C24.3452 16.6992 21.0234 19.8553 21.0234 23.7485C21.0234 27.612 23.3917 32.1198 27.087 33.7312C27.5153 33.9167 27.977 34.0124 28.4437 34.0124C28.9104 34.0124 29.3721 33.9167 29.8004 33.7312C33.4957 32.121 35.864 27.612 35.864 23.7485C35.864 19.8553 32.5422 16.6992 28.4437 16.6992ZM28.4437 26.5929C29.0997 26.5929 29.7288 26.3323 30.1927 25.8685C30.6565 25.4046 30.9171 24.7755 30.9171 24.1195C30.9171 23.4635 30.6565 22.8344 30.1927 22.3705C29.7288 21.9067 29.0997 21.6461 28.4437 21.6461C27.7877 21.6461 27.1586 21.9067 26.6947 22.3705C26.2309 22.8344 25.9703 23.4635 25.9703 24.1195C25.9703 24.7755 26.2309 25.4046 26.6947 25.8685C27.1586 26.3323 27.7877 26.5929 28.4437 26.5929Z' fill='#267CE5'/>
                </svg>
            `" circle_bg_color="#e6f5f0" circle_text_color="#20c661"></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats title="QR Not Found" :tooltipText="'QR Not Found'"
            :tooltipBody="'Kode QR yang tidak ditemukan dalam sistem database'"
            :value="reportSuspectData.stats.qr_not_found" unit="Activities" :icon="`<svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFE8E8'/>
                <path d='M37.5721 34.1065C37.572 34.1065 37.5722 34.1066 37.5721 34.1065L31.9649 28.4992L37.5719 22.8921C37.6302 22.8337 37.6754 22.7632 37.7041 22.6859C37.7807 22.4805 37.737 22.2404 37.5719 22.0752L34.9232 19.4265C34.758 19.2614 34.5179 19.2178 34.3126 19.2944C34.2352 19.3231 34.1649 19.3681 34.1065 19.4263C34.1065 19.4264 34.1065 19.4263 34.1065 19.4263L28.4992 25.0337L22.8921 19.4265C22.8337 19.3683 22.7633 19.3231 22.6859 19.2944C22.4805 19.2178 22.2404 19.2615 22.0753 19.4265L19.4266 22.0753C19.2614 22.2404 19.2178 22.4806 19.2944 22.6859C19.3231 22.7633 19.3681 22.8335 19.4264 22.8919C19.4263 22.8919 19.4265 22.892 19.4264 22.8919L25.0337 28.4992L19.4266 34.1064C19.3683 34.1648 19.3231 34.2352 19.2944 34.3126C19.2177 34.5179 19.2614 34.7581 19.4266 34.9232L22.0753 37.5719C22.2405 37.737 22.4806 37.7807 22.6859 37.7041C22.7633 37.6754 22.8336 37.6304 22.892 37.5721C22.8919 37.5722 22.892 37.572 22.892 37.5721L28.4993 31.9648L34.1064 37.5719C34.1648 37.6302 34.2352 37.6754 34.3126 37.7041C34.518 37.7807 34.7581 37.737 34.9232 37.5719L37.5719 34.9232C37.737 34.7581 37.7807 34.5179 37.7041 34.3126C37.6754 34.2352 37.6304 34.1649 37.5721 34.1065Z' fill='#D05555'/>
                </svg>
            `" circle_bg_color="#ffe8e8" circle_text_color="#d05555"></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats title="Suspicious QR" :tooltipText="'Suspicious QR'"
            :tooltipBody="'Kode QR yang scan lebih dari 5 kali dan di tempat yang berbeda'"
            :value="reportSuspectData.stats.suspicious_qr" unit="Activities" :icon="`<svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFE0F4'/>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M22 17H25.5C26.329 17 27 17.671 27 18.5V25.5C27 26.329 26.329 27 25.5 27H18.5C17.671 27 17 26.329 17 25.5V22C17 19.243 19.243 17 22 17ZM20 22V24H24V20H22C20.897 20 20 20.897 20 22ZM39 25.5C39 26.329 38.329 27 37.5 27H30.5C29.671 27 29 26.329 29 25.5V18.5C29 17.671 29.671 17 30.5 17H34C36.757 17 39 19.243 39 22V25.5ZM34 20H32V24H36V22C36 20.897 35.103 20 34 20ZM17 30.5C17 29.671 17.671 29 18.5 29H25.5C26.329 29 27 29.671 27 30.5V37.5C27 38.329 26.329 39 25.5 39H22C19.243 39 17 36.757 17 34V30.5ZM22 36H24V32H20V34C20 35.103 20.897 36 22 36Z' fill='#E92FA7'/>
                <path d='M33.3431 29C32.7009 28.9996 32.0698 29.1684 31.5135 29.4893C30.9572 29.8103 30.4952 30.2721 30.1741 30.8283C30.0908 30.9669 30.0359 31.1207 30.0126 31.2807C29.9894 31.4407 29.9983 31.6038 30.0387 31.7604C30.0791 31.9169 30.1503 32.0639 30.2482 32.1926C30.346 32.3214 30.4685 32.4294 30.6085 32.5103C30.7485 32.5912 30.9032 32.6434 31.0636 32.6639C31.224 32.6844 31.3868 32.6728 31.5427 32.6296C31.6985 32.5865 31.8442 32.5128 31.9713 32.4128C32.0983 32.3128 32.2042 32.1884 32.2827 32.0471C32.3894 31.8612 32.5431 31.7066 32.7285 31.5989C32.9138 31.4913 33.1243 31.4343 33.3386 31.4338C33.553 31.4333 33.7637 31.4892 33.9496 31.596C34.1354 31.7027 34.2899 31.8565 34.3975 32.0419C34.5051 32.2273 34.5619 32.4378 34.5624 32.6521C34.5628 32.8665 34.5068 33.0772 34.4 33.263C34.2931 33.4488 34.1393 33.6033 33.9538 33.7108C33.7684 33.8183 33.5579 33.8751 33.3436 33.8754C33.0203 33.8754 32.7102 34.0038 32.4816 34.2324C32.253 34.461 32.1246 34.7711 32.1246 35.0943C32.1246 35.4176 32.253 35.7277 32.4816 35.9563C32.7102 36.1849 33.0203 36.3133 33.3436 36.3133C34.3134 36.3132 35.2434 35.9279 35.9291 35.2421C36.6149 34.5564 37.0001 33.6262 37 32.6564C36.9999 31.6866 36.6146 30.7566 35.9288 30.0709C35.2431 29.3851 34.313 28.9999 33.3431 29ZM33.8062 37.63C33.5856 37.5276 33.3393 37.4937 33.0992 37.5325L32.8796 37.6055L32.6601 37.7152L32.4773 37.8736C32.285 38.0569 32.157 38.2975 32.1124 38.5594C32.0678 38.8214 32.1089 39.0908 32.2297 39.3275C32.3505 39.5641 32.5445 39.7555 32.7828 39.8731C33.0211 39.9907 33.291 40.0282 33.5523 39.98C33.8136 39.9319 34.0524 39.8006 34.2332 39.6058C34.4139 39.411 34.527 39.1631 34.5554 38.8989C34.5839 38.6347 34.5264 38.3683 34.3913 38.1395C34.2562 37.9106 34.0509 37.7315 33.8058 37.6287L33.8062 37.63Z' fill='#E92FA7'/>
                </svg>
            `" circle_bg_color="#ffe8e8" circle_text_color="#d05555"></report-suspect-stats>
        </div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- FILTER START -->
    <!-- <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
<div class="row outerBox filterBox">
  <div class="col row">
    <div class="col-md-3 mobileFilterPaddingTop">
      <label for="partshopCode">Range Date</label>
      <flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date"></flat-pickr>
    </div>
    <div class="col-md-3 mobileFilterPaddingTop">
      <label for="partshopCode">Search Distance</label>
      <input v-model="filter.distance" type="text" class="form-control" aria-label="Text input with dropdown button"
        style="height: 43px" placeholder="Type Distance" />
    </div>
    <div class="col-md-3 mobileFilterPaddingTop">
      <label for="partshopCode">Variant</label>
      <MultiSelect v-model="filter.variant" :options="options.variant" :deselect-label="''" placeholder="All Variants"
        class="elegant-multiselect" />
    </div>
    <div class="col-md-3 mobileFilterPaddingTop">
      <label for="partshopCode">Alasan Suspek</label>
      <MultiSelect v-model="filter.reason" :options="['Scan beda tempat', 'Scan lebih dari 5 kali']"
        :deselect-label="''" placeholder="All Alasan" class="elegant-multiselect" />
    </div>
    <div class="col-md-3 mobileFilterPaddingTop" style="
              display: flex;
              flex-direction: column-reverse;
              padding-top: 20px;
            ">
      <button type="button" class="btn btn-primary" style="height: 38px; margin-bottom: 0.5%"
        @click="vue_universal_table.update++">
        Filter
      </button>
    </div>
  </div>
</div>
</panel> -->
    <!-- FILTER END -->

    <!-- Table Start -->
    <div class="bg-white shadow box-content">
      <div class="row">
        <div class="title mb-2 fw-bold">Report Suspect</div>
        <div class="d-flex ml-auto">
          <MultiSelect v-model="filter.part_number" :options="variantOptions" :select-label="''" :deselect-label="''" placeholder="Variant"
            class="mt-1 ml-2" style="width: 200px" />
          <MultiSelect v-model="filter.reason" :options="reasonOptions" :custom-label="formatReasonLabel" :select-label="''"
            :deselect-label="''" placeholder="Reason" class="mt-1 ml-2" style="width: 200px" />
        </div>
      </div>
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>QR Code</th>
                <th>Variant</th>
                <th>Reason</th>
                <th>Total Scan</th>
                <th>Scan Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td>{{ row.qrcode || 'N/A' }}</td>
                <td>{{ row.part_number || 'N/A' }}</td>
                <td>{{ row.reason || 'N/A' }}</td>
                <td>{{ formatNumber(row.total_scan) }}</td>
                <td>{{ formatDateTime(row.scan_date) }}</td>
                <td>
                  <button type="button" class="btn"
                    style="color: #267ce5; background-color: transparent; border: none; text-decoration: underline; font-weight: 400;"
                    @click="seeDetail(row)">
                    Detail
                  </button>
                </td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td colspan="6" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="view-items-per-page"
                style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select id="view-items-per-page" v-model="limitPerPage" @change="onLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (currentPage - 1) * limitPerPage + 1 }}-{{ currentPage * limitPerPage < total ? currentPage *
                  limitPerPage : total }} of {{ total > 0 ? total : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }"
                    @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <suspect-scan-map v-if="modal.map" :filter="modal.mapData" @closeModal="modal.map = false"></suspect-scan-map>
    <!-- Modal End -->
  </div>
</template>

<script>
import moment from "moment";
import debounce from "debounce";

import customFilter from "@/components/filter/customFilter";

import suspectScanMap from "./children/suspectScanMap";
import reportSuspectStats from "./children/ReportSuspectStats.vue";

export default {
  metaInfo: {
    title: "Reports - Suspect",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      reportSuspectData: {
        stats: {
          total_report: null,
          scan_more_than_5: null,
          scan_different_location: null,
          qr_not_found: null,
          suspicious_qr: null,
        },
      },
      modal: {
        map: false,
        mapData: null,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-y",
        altInputClass: "form-control input elegant-flatpickr",
        locale: {
          rangeSeparator: " s/d ",
        },
      },
      options: {
        variant: this.$store.getters.getVariant,
      },
      selected: {
        date: `${startDate} s/d ${currentDate}`,
      },
      filter: {
        start: startDate,
        end: currentDate,
        // variant: null,
        part_number: null,
        reason: null,
        distance: null,
        search: null,
      },
      variantOptions: this.$store.getters.getVariant,
      reasonOptions: ['Scan Different Location', 'Scan More Than 5', 'QR Not Found', 'Suspicious QR'],
      // Table data
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      // Debounce timer
      fetchDataTimer: null,
      tooltip: this.$store.state.tooltip.reports,
    };
  },
  components: {
    customFilter,

    suspectScanMap,
    reportSuspectStats,
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.tableData.length === this.limitPerPage;
    },
  },
  watch: {
    "selected.date": {
      handler: debounce(function (newDate) {
        const separator = this.getRangeSeparator();
        const parts = typeof newDate === 'string' ? newDate.split(separator) : [];
        const startRaw = parts[0] ? parts[0].trim() : '';
        const endRaw = parts.length > 1 && parts[1] ? parts[1].trim() : startRaw;
        const startDate = this.getDatePart(startRaw); // Ensure only YYYY-MM-DD
        const endDate = this.getDatePart(endRaw);

        // Ensure we're storing only the date part without any time
        this.filter.start = startDate;
        this.filter.end = endDate;

        this.loadStatsData();
        this.currentPage = 1;
        this.fetchData();
      }, 300),
    },
    "filter.part_number": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
    "filter.reason": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  },
  mounted() {
    this.loadStatsData();
    this.fetchData();
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  methods: {
    getRangeSeparator() {
      const locale = this.rangePickr && this.rangePickr.locale;
      return (locale && locale.rangeSeparator) || " to ";
    },
    // Helper function to extract date part (YYYY-MM-DD) from date string
    getDatePart(dateString) {
      if (!dateString) return '';
      // Extract only the date part (YYYY-MM-DD), removing any time component
      // This function MUST return ONLY YYYY-MM-DD format, nothing else
      const trimmed = String(dateString).trim();

      // Method 1: If string starts with YYYY-MM-DD format, extract first 10 characters
      if (trimmed.match(/^\d{4}-\d{2}-\d{2}/)) {
        return trimmed.substring(0, 10);
      }

      // Method 2: Split by space and take first part
      const firstPart = trimmed.split(' ')[0];
      if (firstPart.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return firstPart;
      }

      // Method 3: Use moment to parse and format
      const momentDate = moment(trimmed);
      if (momentDate.isValid()) {
        return momentDate.format('YYYY-MM-DD');
      }

      // Fallback: return first 10 characters if available
      return trimmed.length >= 10 ? trimmed.substring(0, 10) : trimmed;
    },
    // Helper function to format date with time for API
    formatDateForAPI(dateString, isStart = true) {
      if (!dateString) return '';
      // First, extract only the date part to ensure no time is included
      const datePart = this.getDatePart(dateString);
      // Then add time only once
      return isStart ? `${datePart} 00:00:00` : `${datePart} 23:59:59`;
    },
    async loadStatsData() {
      let url = [
        {
          url: "/api/reports/suspect-report/total",
          variable: "total_report",
        },
        {
          url: "/api/reports/suspect-report/total?reason=Scan Different Location",
          variable: "scan_different_location",
        },
        {
          url: "/api/reports/suspect-report/total?reason=Scan More Than 5",
          variable: "scan_more_than_5",
        },
        {
          url: "/api/reports/suspect-report/total?reason=QR Not Found",
          variable: "qr_not_found",
        },
        {
          url: "/api/reports/suspect-report/total?reason=Suspicious QR",
          variable: "suspicious_qr",
        },
      ];

      try {
        // CRITICAL: Always extract ONLY the date part (YYYY-MM-DD) from filter dates
        const cleanStartDate = this.getDatePart(this.filter.start);
        const cleanEndDate = this.getDatePart(this.filter.end);

        // Send dates without time (YYYY-MM-DD format only)
        for (const item of url) {
          this.reportSuspectData.stats[item.variable] = null;

          const baseUrl = item.url;
          const separator = baseUrl.includes("?") ? "&" : "?";

          const resp = await this.$http.get(`${baseUrl}${separator}start=${encodeURIComponent(cleanStartDate)}&end=${encodeURIComponent(cleanEndDate)}`);

          this.reportSuspectData.stats[item.variable] = Number.parseInt(resp.data.data.total, 10);
        }
      } catch (err) {
        console.log(err);
      }
    },
    seeDetail(row) {
      // row is now a direct object, not a JSON string
      this.modal.mapData = {
        qrcode: row.qrcode,
        start: this.filter.start,
        end: this.filter.end,
        reason: row.reason,
        distance: this.filter.distance,
      };
      this.modal.map = true;
    },
    formatReasonLabel(option) {
      if (!option) {
        return option;
      }

      if (typeof option === 'string' && option.trim() === 'Scan Different Location') {
        return 'Different Location';
      }

      return option;
    },
    async fetchData() {
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300); // 300ms debounce
    },
    async performFetchData() {
      this.tableLoading = true;

      try {
        // CRITICAL: Always extract ONLY the date part (YYYY-MM-DD) from filter dates
        // This ensures no time component is included, preventing duplication
        // Convert to string first to handle any edge cases
        const startDateStr = String(this.filter.start || '').trim();
        const endDateStr = String(this.filter.end || '').trim();

        // Extract ONLY the date part - use substring to get first 10 characters (YYYY-MM-DD)
        // This is the most reliable way to ensure we never include time
        const cleanStartDate = startDateStr.length >= 10 ? startDateStr.substring(0, 10) : this.getDatePart(startDateStr);
        const cleanEndDate = endDateStr.length >= 10 ? endDateStr.substring(0, 10) : this.getDatePart(endDateStr);

        // Double-check: ensure we only have YYYY-MM-DD format (exactly 10 characters)
        const finalStartDate = cleanStartDate.match(/^\d{4}-\d{2}-\d{2}$/) ? cleanStartDate : this.getDatePart(startDateStr);
        const finalEndDate = cleanEndDate.match(/^\d{4}-\d{2}-\d{2}$/) ? cleanEndDate : this.getDatePart(endDateStr);

        // Update filter to ensure it's always clean (without time)
        this.filter.start = finalStartDate;
        this.filter.end = finalEndDate;

        // Build query parameters - send dates without time (YYYY-MM-DD format only)
        let queryParams = {
          start: finalStartDate,
          end: finalEndDate,
          limit: this.limitPerPage,
          page: this.currentPage,
        };

        // Add part_number filter
        if (this.filter.part_number) {
          if (Array.isArray(this.filter.part_number)) {
            queryParams.part_number = this.filter.part_number.join(',');
          } else {
            queryParams.part_number = this.filter.part_number;
          }
        }

        // Add reason filter
        if (this.filter.reason) {
          if (Array.isArray(this.filter.reason)) {
            queryParams.reason = this.filter.reason.join(',');
          } else {
            queryParams.reason = this.filter.reason;
          }
        }

        // Build URL
        let separator = "/api/reports/suspect-report/table".includes("?") ? "&" : "?";
        let url = `/api/reports/suspect-report/table${separator}`;

        for (let key in queryParams) {
          if (queryParams[key] != null && queryParams[key] !== '') {
            const value = String(queryParams[key]);
            url += `${key}=${encodeURIComponent(value)}&`;
          }
        }
        url = url.slice(0, -1); // Remove trailing &

        const resp = await this.$http.get(url);

        let data = resp.data.data || [];

        // Process data (from the original process_data)
        for (const item of data) {
          item.qrcode = item.qrcode ? item.qrcode : '-';
          item.part_number = item.part_number ? item.part_number : '-';
          item.reason = item.reason ? item.reason : '-';
          item.scan_date = item.scan_date ? item.scan_date : '-';
        }

        // Check for pagination meta
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        // Handle pagination metadata
        const currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;

        // If total is 0 but we have data, estimate
        if (total === 0) {
          if (data.length === this.limitPerPage) {
            total = this.currentPage * this.limitPerPage;
            lastPage = this.currentPage + 1;
          } else if (data.length > 0) {
            total = (this.currentPage - 1) * this.limitPerPage + data.length;
            lastPage = this.currentPage;
          } else {
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.limitPerPage);
          }
        }

        lastPage = Math.max(1, lastPage);

        // If we got a full page and we're on the last calculated page, there might be more
        if (data.length === this.limitPerPage && this.currentPage >= lastPage) {
          lastPage = this.currentPage + 1;
        }

        // Update pagination state
        this.$set(this, 'currentPage', Number.parseInt(currentPage, 10));
        this.$set(this, 'maxPage', Number.parseInt(lastPage, 10));
        this.$set(this, 'total', Number.parseInt(total, 10));
        this.$set(this, 'tableData', data);
      } catch (err) {
        console.log('Error fetching suspect report data:', err);
        this.$set(this, 'tableData', []);
        this.$set(this, 'currentPage', 1);
        this.$set(this, 'maxPage', 1);
        this.$set(this, 'total', 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, 'currentPage', 1);
      this.fetchData();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.currentPage;

      if (opt === 'prev') {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (opt === 'next') {
        // Allow going to next page if we have more data or if we're not at maxPage
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return; // Can't go to next page
        }
      }

      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, 'currentPage', newPage);
        this.fetchData();
      }
    },
    formatNumber(num) {
      if (!num && num !== 0) return 'N/A';
      return Number.parseInt(num, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      const parsed = moment(dateString);
      if (!parsed.isValid()) {
        return dateString || 'N/A';
      }
      return parsed.format('YYYY-MM-DD | HH:mm:ss');
    },
    changeFilter(filter) {
      for (const key in filter) {
        if (Object.prototype.hasOwnProperty.call(filter, key)) {
          this.filter[key] = filter[key];
        }
      }
    },
    async fetchVariant() {
      try {
        // const response = await fetch('master/products');
        // const products = await response.json();

        // const response = await this.$http.get('master/products');
        // const products = response.data.data;

        // console.log(products);
        // Assuming the API returns an array of product objects with a `part_number` property

        const dateRange = this.selected.date || '';
        const separator = this.getRangeSeparator();
        const dateParts = dateRange.split(separator);
        const startDate = this.getDatePart(dateParts[0]);
        const endDate = this.getDatePart(dateParts[1] || dateParts[0]);

        let apiEndpoint = `/api/reports/suspect-report/table?start=${startDate}&end=${endDate}`;
        // let apiEndpoint = `suspect-report/?start=2024-01-01&end=2025-01-10&page=9`;

        if (this.filter.part_number) {
          apiEndpoint += `&part_number=${this.filter.part_number}`;
        }

        // if (this.filter.distance) {
        //   apiEndpoint += `&distance=${this.filter.distance}`;
        // }

        // if (this.filter.reason === "QR Not Found") {
        //   console.log("this filter reason QR NOT FOUND:", this.filter.reason);

        //   apiEndpoint += `&reason=Fake`;
        // } else
        // if (this.filter.reason) {
        // console.log("this filter reason ELSE:", this.filter.reason);
        //   apiEndpoint += `&reason=${this.filter.reason}`;
        // }

        let resp = await this.$http.get(apiEndpoint);

        const lastPage = resp.data.meta.lastPage;
        let allVariants = [];

        if (resp.data.meta.lastPage > 1) {
          allVariants = await this.fetchAllVariants(apiEndpoint, lastPage);
        } else {
          allVariants = resp.data.data;
        }

        // const products = resp.data.data;

        // const products = resp.data.data;

        //    this.partNumberOptions = products.map(product => product.part_number);

        // Group the products by part_number
        const groupedProducts = allVariants.reduce((acc, product) => {
          if (!acc[product.part_number]) {
            acc[product.part_number] = [];
          }
          acc[product.part_number].push(product);
          return acc;
        }, {});

        // Transform groupedProducts into an array of part numbers
        const arrVariants = Object.keys(groupedProducts);
        // console.log("part numbers:", arrVariants);
        // console.log();

        // this.partNumberOptions = arrPartNumber.filter(
        //   (item) => !item.includes("(Inactive)")
        // );

        // const cleanedArrPartNumber = arrPartNumber
        //   .map((item) => {
        //     if (item === "Unknown") {
        //       return item; // Keep 'Unknown' as is
        //     }
        //     const match = item
        //       .replace(" (Inactive)", "")
        //       .match(/[a-zA-Z0-9]+/g);
        //     return match ? match.join("-") : null; // Safely handle possible null match
        //   })
        //   .filter((item) => item);

        // this.partNumberOptions = [...new Set(cleanedArrPartNumber)];
        this.variantOptions = arrVariants;

        // console.log("dirty all part number array:", arrPartNumber);
        // console.log("clean all part number array:", cleanedArrPartNumber);
        // console.log("all variant:", this.variantOptions);
      } catch (error) {
        console.error("Error fetching variants:", error);
      }
    },
    async fetchAllVariants(baseUrl, lastPage) {
      // let currentPage = 1;
      let allVariants = [];

      for (let i = 1; i <= lastPage; i++) {
        const resp = await this.$http.get(`${baseUrl}&page=${i}`);
        const data = await resp.data.data;
        allVariants = allVariants.concat(data);
        // console.log(`fetch page ${i}:`, data);
      }

      // console.log("all variants array:", allVariants);
      return allVariants;
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 13px;
  font-weight: bold;
  color: #383838;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>